import { type Inspiration } from "@repo/api";
import {
  Accordion,
  AccordionItem,
  ProductIdentifier,
  Text,
  Variables,
} from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv, Line } from "@repo/ui";
import { hasItems, isLastItem } from "@repo/utils";

export const InspirationArticles = ({
  id,
  articles,
}: {
  id: string;
  articles?: Inspiration["pricingProducts"];
}) => {
  if (!articles) {
    return null;
  }
  return (
    <Accordion>
      {Object.entries(articles).map(([key, value]) => (
        <AccordionItem key={`${id}-${key}`} id={`${id}-${key}`} title={key}>
          <FlexDiv flexDirection="column" gap={Variables.space75}>
            {!hasItems(value) ? (
              <Text>{t("prompt.no_items")}</Text>
            ) : (
              value.map((item, index) => (
                <>
                  <FlexDiv
                    key={`${id}-${key}-${item.productNo}`}
                    justifyContent="space-between"
                  >
                    <ProductIdentifier value={item.productNo} />
                    <Text textStyle="Heading.XS">x {item.quantity ?? 1}</Text>
                  </FlexDiv>
                  {!isLastItem(value, index) && <Line />}
                </>
              ))
            )}
          </FlexDiv>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
